// TODO: breakout priority enum to be more flexible
enum AvatarPriorityEnum {
  DEFAULT = "default",
  PRIMARY = "primary",
  SECONDARY = "secondary",
  VEHICLE = "vehicle",
  CELEBRATE = "celebrate"
}
export default AvatarPriorityEnum;
